<!-- Back2Top.vue -->
<template>
	<transition enter-active-class="el-fade-in-enter-active" leave-active-class="el-fade-in-leave-active">
		<div v-show="visible" @click="backToTop" class="back-to-top-btn"></div>
	</transition>
</template>

<style>
	.back-to-top-btn {
		/* 设置背景图片 */
		background-image: url('../assets/img/Back2Top.png');
		/* 确保图片覆盖整个div */
		background-size: cover;
		/* 防止图片重复 */
		background-repeat: no-repeat;
		
		position: fixed;
		right: 40px;
		bottom: 40px;
		width: 60px;
		height: 60px;
		/* padding: 5px; */
		z-index: 9999;
		/* border: 1px solid #fff; */
		border-radius: 10px;
		cursor: pointer;
	}
	
	.back-to-top-btn:hover::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.1);
		border-radius: 10px;
		/* 黑色半透明蒙版 */
		z-index: 1;
	}

	/* 确保内容在蒙版上方 */
	.back-to-top-btn>* {
		position: relative;
		z-index: 2;
	}
</style>

<script>
	export default {
		name: 'Back2Top',
		props: {
			visibilityHeight: {
				type: Number,
				default: 300
			},
			target: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				visible: false,
				container: null
			}
		},
		mounted() {
			this.init()
		},
		beforeDestroy() {
			this.destroy()
		},
		methods: {
			init() {
				this.container = this.target ?
					document.querySelector(this.target) :
					window
				this.container.addEventListener('scroll', this.handleScroll)
			},
			destroy() {
				this.container.removeEventListener('scroll', this.handleScroll)
			},
			handleScroll() {
				const scrollTop = this.container.pageYOffset ||
					this.container.scrollTop ||
					document.documentElement.scrollTop
				this.visible = scrollTop > this.visibilityHeight
			},
			backToTop() {
				const target = this.target ?
					document.querySelector(this.target) :
					window

				target.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			}
		}
	}
</script>